import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { STYLES } from "@/data/site";
import { FadeUp, Chapter, RevealLines } from "./motion";

export default function Styles() {
  const track = useRef(null);
  const scroll = (dir) => track.current?.scrollBy({ left: dir * 380, behavior: "smooth" });

  return (
    <section id="styles" data-testid="styles-section" className="bg-[#F7F5F2] py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="flex items-end justify-between gap-6">
          <div>
            <Chapter num="12" title="Design Styles" />
            <RevealLines
              className="mt-8 font-display text-4xl tracking-tight text-[#1B1B1B] md:text-6xl"
              lines={[<>Find the style</>, <>that <span className="italic text-[#B68D40]">is</span> you.</>]}
            />
          </div>
          <FadeUp delay={0.2} className="hidden gap-3 md:flex">
            <button onClick={() => scroll(-1)} data-testid="styles-prev-btn" className="flex h-12 w-12 items-center justify-center rounded-full border hairline text-[#1B1B1B] transition-colors hover:bg-[#1B1B1B] hover:text-[#F7F5F2]" aria-label="Previous styles">
              <ChevronLeft size={18} />
            </button>
            <button onClick={() => scroll(1)} data-testid="styles-next-btn" className="flex h-12 w-12 items-center justify-center rounded-full border hairline text-[#1B1B1B] transition-colors hover:bg-[#1B1B1B] hover:text-[#F7F5F2]" aria-label="Next styles">
              <ChevronRight size={18} />
            </button>
          </FadeUp>
        </div>
      </div>

      <FadeUp delay={0.25}>
        <div
          ref={track}
          data-testid="styles-carousel"
          data-cursor="Scroll"
          className="mt-14 flex snap-x snap-mandatory gap-5 overflow-x-auto px-6 pb-4 md:px-12 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        >
          {STYLES.map((s, i) => (
            <div key={s.name} data-testid={`style-${s.name.toLowerCase()}`} className="group relative h-[420px] w-[300px] shrink-0 snap-start overflow-hidden rounded-xl md:w-[340px]">
              <img
                src={s.img}
                alt={`${s.name} interior design style`}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1B1B1B]/75 via-transparent to-transparent" />
              <span className="absolute left-6 top-6 font-num text-xs tracking-[0.3em] text-[#F7F5F2]/70">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="absolute bottom-6 left-6 font-display text-3xl text-[#F7F5F2] transition-colors duration-300 group-hover:text-[#B68D40]">{s.name}</h3>
            </div>
          ))}
        </div>
      </FadeUp>
    </section>
  );
}
